import { PageHero } from "@/components/PageHero";

const SECTIONS = [
  { h: "Overview", p: "This Privacy Policy explains how Employee 2 Employer collects, uses, and protects your information when you visit our website or purchase our products. By using this site, you agree to the practices described here." },
  { h: "Information We Collect", p: "We collect information you provide directly — such as your name and email when you contact us, subscribe, or make a purchase — as well as basic usage data collected automatically to help us improve the site." },
  { h: "How We Use Your Information", p: "We use your information to deliver products and updates, respond to your messages, improve our content, and communicate about the Builder Movement. We do not sell your personal information." },
  { h: "Payments", p: "Purchases are processed by secure third-party payment providers. We do not store your full payment card details on our servers." },
  { h: "Your Choices", p: "You may unsubscribe from emails at any time using the link in any message, or contact us to request access to or deletion of your information." },
  { h: "Contact", p: "Questions about this policy? Reach us through the Contact page and we’ll respond promptly." },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHero eyebrow="Legal" title="Privacy Policy" testId="privacy-hero" />
      <section className="bg-white text-black py-24 lg:py-32">
        <div className="max-w-[820px] mx-auto px-6 lg:px-10 space-y-12">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="font-display text-2xl lg:text-3xl">{s.h}</h2>
              <p className="font-body text-lg text-black/65 mt-4 leading-relaxed">{s.p}</p>
            </div>
          ))}
          <p className="font-body text-sm text-black/40 pt-6 border-t border-[#e5e5e5]">
            Last updated {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long" })}.
          </p>
        </div>
      </section>
    </div>
  );
}
